import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum } from '../_themes';

import useThemeContext from './useThemeContext';

/**
 * Hook Typings
 */

type MapType<TMap> = TMap extends MatchedMap<ThemeEnum, infer MapValue> ? MapValue : never;
type BaseValue = Record<string, unknown>;

/**
 * Hook Definition
 */

const useTheme = <
  CommonClasses extends BaseValue,
  ThemeMap extends MatchedMap<ThemeEnum, BaseValue>,
  ThemeClasses extends MapType<ThemeMap>,
>(
  commonClasses: CommonClasses,
  themeClassesMap: ThemeMap,
) => {
  const { currentTheme } = useThemeContext();

  const themeClasses = themeClassesMap.get(ThemeEnum[currentTheme]) as ThemeClasses;

  return { ...commonClasses, ...themeClasses };
};

/**
 * Hook Exports
 */

export default useTheme;
